import { AxiosInstance } from 'axios';
import {
  IFetchCategoriesParams,
  ISendUsefulData,
  TFetchCategoriesResponse,
  TFetchTopicsResponse,
} from '@sv-support-sdk/shared-types/src/api/helpCenter';
import { IHelpCenterTopic } from '@sv-support-sdk/shared-types/src/common/helpCenter';

export default (api: AxiosInstance) => ({
  getCategories: (params: IFetchCategoriesParams): Promise<TFetchCategoriesResponse> =>
    api.get('help-center/category', { params }),
  getTopics: (): Promise<TFetchTopicsResponse> => api.get('help-center/topic'),
  sendUseful: (slug: string, data: ISendUsefulData): Promise<IHelpCenterTopic> =>
    api.put(`help-center/topic/${slug}/useful`, data),
});
